"use strict";
/*
 * Copyright (C) 2024 Klaus Reimer <k@ailis.de>
 * See LICENSE.md for licensing information.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTilesetRef = exports.isEmbeddedTileset = void 0;
/**
 * Checks if given tileset is an embedded tileset.
 *
 * @params tileset - The tileset to check.
 * @returns True if tileset is an embedded tileset, false if not.
 */
function isEmbeddedTileset(tileset) {
    return tileset.source == null;
}
exports.isEmbeddedTileset = isEmbeddedTileset;
/**
 * Checks if given tileset is a external tileset reference.
 *
 * @params tileset - The tileset to check.
 * @returns True if tileset is an external tileset reference, false if not.
 */
function isTilesetRef(tileset) {
    return tileset.source != null;
}
exports.isTilesetRef = isTilesetRef;
//# sourceMappingURL=AnyTileset.js.map